import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'

import Header from 'components/ui/header'
import CircleFinish from 'components/ui/finish_circle'

import Colors from 'utils/colors'
import { RiArrowGoBackLine } from 'react-icons/ri'
import { IoMdClose, IoMdCheckmark } from "react-icons/io";
import { postResult } from 'services/result'

const LoserView = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = location.state || {}
  const { answers } = location.state || {}
  const { lenght } = location.state || {}
  const { result } = location.state || []

  console.log(answers)
  console.log(lenght)


  useEffect(()=>{
    init()
    return () => {}
  },[])

  const init = async () => {
    const body = {
      idActivity: parseInt(id),
      status: '0',
      user: 'Lose',
    }
    const response = await postResult(body)

  }
  return (
    <div className="finish-container" style={styles.container}>
      <Header />
      <div className="circle-container-loser">
        <CircleFinish
          size={'545px'}
          gradient={`linear-gradient(244.04deg, ${Colors.warning} -9.61%, ${Colors.danger} 66.41%)`}
        />
      </div>
      <img src={'images/sad-face.png'} alt="Sad Face" style={styles.image} />
      <div style={styles.containerText}>
        <h1 className="responsive-text-loser" style={styles.almost}>
          ¡Casi lo logras!
        </h1>
        <h2 style={styles.tryAgain}>Acertaste {answers} de {lenght} preguntas.</h2>

        <div className='d-flex justify-content-between mt-5'>
            {result.map((result, i)=>{
              if(result === 1){
                return (
                  <div className='result-icon-check' key={i}>
                    <IoMdCheckmark color='white' size={20}></IoMdCheckmark>
                  </div>
                )
              }else{
                return (
                  <div className='result-icon-close' key={i}>
                    <IoMdClose color='white' size={20}></IoMdClose>
                  </div>
                )
              }
             
            })}
        </div>
      </div>
      <div style={styles.containerText}>
        <h1 style={styles.tryAgain}>Sigue intentándolo y conviértete en un experto.</h1>
        <h1 style={styles.tryAgain}>¡La próxima vez el premio será tuyo!</h1>
      </div>
      <Button
        style={styles.button}
        className="mb-3"
        onClick={() => {
          navigate(`/${id}`)
        }}
      >
        <RiArrowGoBackLine style={styles.iconBack} />
        Volver a intentar
      </Button>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: `linear-gradient(178.7deg, ${Colors.danger} 66.8%, ${Colors.warning} 157.05%)`,
  },
  containerText: {
    marginBottom: '5%',
  },
  almost: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  tryAgain: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
  },
  image: {
    maxWidth: '30%',
    maxHeight: '30%',
    objectFit: 'contain',
    marginTop: '5%',
    marginBottom: '8%',
  },
  button: {
    backgroundColor: Colors.yelmoPurple,
    borderColor: Colors.yelmoPurple,
    height: '45px',
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: 'large',
    width: '50%',
    marginLeft: '2%',
    borderRadius: '10px',
  },
  iconBack: {
    fontSize: '16px',
    marginRight: '2%',
  },
}

export default LoserView
